import { render, staticRenderFns } from "./TokenListView.vue?vue&type=template&id=49ed009e&scoped=true"
import script from "./TokenListView.vue?vue&type=script&lang=js"
export * from "./TokenListView.vue?vue&type=script&lang=js"
import style0 from "./TokenListView.vue?vue&type=style&index=0&id=49ed009e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ed009e",
  null
  
)

export default component.exports